import React, { memo, useEffect, useRef } from 'react'
import { disableBodyScroll, enableBodyScroll } from 'body-scroll-lock'
import { RootState } from '@/app/store'
import { dialogState } from '@/features/dialogSlice'
import { useSelector, useDispatch } from 'react-redux'

type DialogTYPE = {
  children: React.ReactNode
  title?: string
  titleSmall?: boolean
  discription?: string
  image?: string
  buttonOff?: boolean
  selectorState?: boolean
  dispatchAction?: any
}

const Dialog = memo(
  ({
    children,
    title,
    titleSmall = false,
    discription,
    image,
    buttonOff,
    selectorState,
    dispatchAction,
  }: DialogTYPE) => {
    const dialogStateSelector = dispatchAction
      ? selectorState
      : useSelector((dialogState: RootState) => dialogState.dialog.boolean)

    const dispatch = useDispatch()
    const dialogElem = useRef(null)

    useEffect(() => {
      if (!dialogStateSelector) {
        disableBodyScroll(dialogElem.current)
        return
      }

      enableBodyScroll(dialogElem.current)
      return
    }, [dialogStateSelector])

    const CloseButton = () => {
      enableBodyScroll(dialogElem.current)

      if (dispatchAction) {
        dispatch(dispatchAction(true))
      } else {
        dispatch(dialogState(true))
      }
    }

    return (
      <article
        className="c-dialog"
        id="my-dialog"
        aria-hidden={dialogStateSelector}
      >
        <div className="c-dialog-overlay" onClick={() => CloseButton()}></div>
        <div className="c-dialog-wrap">
          {buttonOff ? (
            ''
          ) : (
            <button
              type="button"
              className="c-dialog-close"
              aria-label="dialog close button"
              onClick={() => CloseButton()}
            >
              <span className="block">
                <img
                  src={`${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/images/img_close_button.svg`}
                  alt=""
                />
              </span>
            </button>
          )}
          <div
            role="dialog"
            className="c-dialog-content"
            aria-labelledby="dialog"
            ref={dialogElem}
          >
            {title && (
              <h1
                className={`text-gray-600 text-center ${
                  titleSmall ? 'text-h2' : 'text-h1'
                } font-bold uppercase`}
                dangerouslySetInnerHTML={{
                  __html: title,
                }}
              ></h1>
            )}

            {image && (
              <div className="mx-auto mt-5 h-24 w-24 rounded-full text-center">
                <img
                  src={`${process.env.NEXT_PUBLIC_SITEURL}/${process.env.NEXT_PUBLIC_SERVICE_NAME}/images/img_demo_stamp.png`}
                  alt={image}
                />
              </div>
            )}

            {discription && (
              <p
                className="text-gray-600 mt-5 text-center text-sm font-bold uppercase"
                dangerouslySetInnerHTML={{
                  __html: discription,
                }}
              ></p>
            )}

            {dialogStateSelector === false ? children : ''}
          </div>
        </div>
      </article>
    )
  }
)

export default Dialog
